const APP_VERSION = '1.0.1';
// export const isDevEnv = NODE_ENV === "development";
// export const isProdEnv = NODE_ENV === "production";

export const TOUR_SEARCH_INTERVAL     = 2000;
export const TOUR_SEARCH_TIMES_LIMIT  = 200;

export const TOURS_LIST_EMPTY = [];

export const HOTELS_LIMIT = 50;

export const DATES_LIST = [];
export const DATE_FROM_OFFSET = 3;
export const DATE_TO_OFFSET = 16;

export const COUNTRY_LIST = [];

export const COUNTRY_RANK_DIC = {
    "0": "Топовые страны",
    "1": "Популярные страны",
    "2": "Остальные страны"
}

export const REQUEST_KEYS_MAP = {
  pageSize: 'onpage',
  countryId: 'country',
  s_departFrom: 'datefrom',
  s_departTo: 'dateto',
  nightsfrom: 'nightsfrom',
  nightsto: 'nightsto',
  cityFromId: 'departure',
  service: 'services',
  cities: 'region',
  operators: 'operators',
  subregion: 'subregion'
}


